package learning.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.grid.col
import antd.grid.row
import antd.input.input
import antd.message.message
import antd.modal.modal
import antd.pageheader.pageHeader
import antd.select.*
import com.jingfangpai.common.constant.Error
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.model.IdName
import com.jingfangpai.common.data.model.Result
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentStatus
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.common.orm.mapping.enums.ContentEntityType
import com.jingfangpai.content.model.ContentQuery
import com.jingfangpai.content.model.ContentVo
import com.jingfangpai.contentEntity.model.ContentConnectionDto
import com.jingfangpai.contentEntity.model.ContentConnections
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import external.select.filterOptionFun
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinext.js.Object
import kotlinext.js.js
import kotlinext.js.jsObject
import org.w3c.dom.HTMLScriptElement
import react.*
import react.dom.div
import react.dom.span
import learning.containers.ShangHanLunReadingPageContext
import learning.model.CommentVo
import react.dom.jsStyle
import user.service.AuthService

external interface ShangHanLunReadingProps : RProps {

}

val ShangHanLunReading = functionalComponent<ShangHanLunReadingProps> { props ->

    val bookId = "3f632feb6bb711eca8bb525400cdb4bd"
    val ctx = useContext(ShangHanLunReadingPageContext)
    val (contents,setContents) = useState(arrayOf<ContentVo>())
    val (containers,setContainers) = useState(arrayOf<CascadedOption<String>>())
    val (commentMap,setCommentMap) = useState(hashMapOf<String, CommentVo>())
    val (signSymptomOptions,setSignSymptomOptions) = useState(arrayOf<CascadedOption<String>>())
    //val (searchKey,setSearchKey) = useState("")
    val (refreshKey, setRefreshKey) = useState(0)
    val (bookContentQuery,setBookContentQuery) = useState(ContentQuery().apply {
        entityType = ContentEntityType.Book
        entityId = bookId
        includeComments = true
    })

    // Annotation editor state
    val (showAnnotationModal, setShowAnnotationModal) = useState(false)
    val (editingAnnotation, setEditingAnnotation) = useState<Comment?>(null)
    val (editingAnnotationContentId, setEditingAnnotationContentId) = useState<String>("")
    val (annotationForm, setAnnotationForm) = useState(Comment())
    val (savingAnnotation, setSavingAnnotation) = useState(false)
    val (saveAnnotationError, setSaveAnnotationError) = useState<String?>(null)
    val (annotationEditor, setAnnotationEditor) = useState<CKEditor?>(null)
    val (editorScriptLoaded, setEditorScriptLoaded) = useState(false)

    // CKEditor Base64 image upload adapter
    val configureBase64Upload = js("""
function(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = function(loader) {
        return {
            upload: function() {
                return loader.file.then(function(file) {
                    return new Promise(function(resolve) {
                        var reader = new FileReader();
                        reader.onload = function() { resolve({ 'default': reader.result }); };
                        reader.readAsDataURL(file);
                    });
                });
            }
        };
    };
}
""").unsafeCast<(dynamic) -> Unit>()

    // Load CKEditor script once (global singleton)
    useEffectOnce {
        if (js("typeof ClassicEditor !== 'undefined'").unsafeCast<Boolean>()) {
            setEditorScriptLoaded(true)
        } else if (document.getElementById("ckeditor-script-global") != null) {
            setEditorScriptLoaded(true)
        } else {
            val s = document.createElement("script") as HTMLScriptElement
            s.src = "/ckeditor.js"
            s.id = "ckeditor-script-global"
            document.body?.appendChild(s)
            s.onload = {
                setEditorScriptLoaded(true)
            }
        }
    }

    // Initialize / cleanup editor when annotation modal visibility changes
    useEffect(showAnnotationModal, editorScriptLoaded) {
        if (showAnnotationModal && editorScriptLoaded) {
            js("setTimeout")({
                val el = document.querySelector("#annotation-editor-reading")
                if (el != null) {
                    val config = jsObject<EditorConf> {
                        toolbar = jsObject<EditorToolbarConf> {
                            shouldNotGroupWhenFull = true
                            items = arrayOf(
                                "bold", "italic", "underline",
                                "fontSize", "fontColor", "link",
                                "bulletedList", "numberedList",
                                "|",
                                "outdent", "indent",
                                "|",
                                "imageUpload", "blockQuote",
                                "undo", "redo"
                            )
                        }
                        language = "zh-cn"
                        licenseKey = ""
                    }
                    ClassicEditor.create(el, config)
                        .then { editor: dynamic ->
                            configureBase64Upload(editor)
                            setAnnotationEditor(editor.unsafeCast<CKEditor>())
                            annotationForm.comment?.let { data ->
                                editor.setData(data)
                            }
                            editor.model.document.on("change:data") { _: dynamic, _: dynamic ->
                                val newComment = editor.getData() as String
                                setAnnotationForm { current ->
                                    Object.assign(Comment(), current).apply {
                                        comment = newComment
                                    }
                                }
                            }
                        }
                        .catch { error: dynamic ->
                            console.error("CKEditor init failed:", error)
                        }
                }
            }, 150)
        }
    }

    fun destroyAnnotationEditor() {
        annotationEditor?.let { editor ->
            try {
                editor.asDynamic().destroy()
            } catch (e: dynamic) {
                console.log("Editor destroy error:", e)
            }
        }
        setAnnotationEditor(null)
        val el = document.querySelector("#annotation-editor-reading")
        if (el != null) {
            el.innerHTML = ""
        }
    }

    fun openAnnotationModal(comment: Comment, contentId: String) {
        setEditingAnnotation(comment)
        setEditingAnnotationContentId(contentId)
        setSaveAnnotationError(null)
        setAnnotationForm(Object.assign(Comment(), comment))
        setShowAnnotationModal(true)
    }

    fun queryContent(query:ContentQuery?=null){
        ctx.query(if(query !=null)query else bookContentQuery,{ resp->
            if(resp.ok()) {
                resp.data?.let{
                    setContents(it)
                }
            }else{
                message.error("获取内容出错：${resp.message}")
            }
        },{
            console.log(it)
            message.error("获取内容出错：${it.message}")
        })
    }

    fun handleSaveAnnotation() {
        val editorComment = annotationEditor?.asDynamic()?.getData() as? String
        val commentToSave = editorComment ?: editingAnnotation?.comment

        if (commentToSave.isNullOrBlank()) {
            setSaveAnnotationError("请输入注解内容")
            return
        }

        setSavingAnnotation(true)
        setSaveAnnotationError(null)
        destroyAnnotationEditor()

        val toSave = Object.assign(Comment(), editingAnnotation ?: Comment()).apply {
            comment = commentToSave
            entityType = CommentEntityType.Content
            entityId = editingAnnotationContentId
            type = CommentType.注解
            status = CommentStatus.正常
            title = annotationForm.title
            source = annotationForm.source
        }
        if (toSave.createdBy == null) {
            toSave.createdBy = AuthService.getUserAuthData()?.id
        }
        if (toSave.createdOn == null) {
            toSave.createdOn = DateTime()
        }

        ctx.saveComment(
            toSave,
            { resp ->
                if (resp.ok()) {
                    message.success("保存成功")
                    setShowAnnotationModal(false)
                    setEditingAnnotation(null)
                    setAnnotationForm(Comment())
                    queryContent(bookContentQuery)
                } else {
                    message.error("保存失败：${resp.message}")
                }
                setSavingAnnotation(false)
            },
            { error ->
                message.error("保存失败：${error.message}")
                setSavingAnnotation(false)
            }
        )
    }

    fun getContainers(){
        ctx.getContainers(ContentEntityType.Book,bookId,null,{ resp->
            if(resp.ok()) {
                resp.data?.let{
                    setContainers(it)
                    val savedChapter = window.localStorage.getItem("shanghanlun_reading_chapter")
                    val firstChapter = it[0].value
                    val selectedChapter = if (savedChapter != null && it.any { c -> c.value == savedChapter }) {
                        savedChapter
                    } else {
                        firstChapter
                    }
                    val _bookContentQuery = Object.assign(ContentQuery(),bookContentQuery)
                    _bookContentQuery.id = selectedChapter
                    setBookContentQuery(_bookContentQuery)
                    queryContent(_bookContentQuery)
                }
            }else{
                message.error("获取章节出错：${resp.message}")
            }
        },{
            console.log(it)
            message.error("获取章节出错：${it.message}")
        })
    }

    /**
     * 保存内容关联
     */
    fun onSaveConnection(itemIndex:Int, contentConnection: ContentConnectionDto, callback:(Result)->Unit){
        ctx.saveContentConnection(contentConnection,{ resp->
            if(resp.ok() && resp.data != null){
                /*val _contents = Object.assign(arrayOf<ContentVo>(),contents)
                var content = _contents[itemIndex].children.firstOrNull { it.id == contentConnection.contentId }
                if(content != null){
                    val connectionsOfType = content.connections.firstOrNull { it.contentId == contentConnection.contentId && it.entityType == contentConnection.entityType }?: ContentConnections().apply { contentId = contentConnection.contentId;entityType = contentConnection.entityType; }
                    connectionsOfType.connectedEntities += com.jingfangpai.contentEntity.model.ConnectedEntityInfo(
                        resp.data!!.id ?: "", contentConnection.entityName ?: "", contentConnection.relationType
                    )
                }*/
                queryContent(bookContentQuery)
                callback(Result(Error.NA,"保存成功"))

            }else{
                callback(Result(Error.操作失败,resp.message?:"未知错误"))
            }
        },{
            callback(Result(Error.操作失败,it.message?:"未知错误"))
        })
    }

    /**
     * 从界面上移除已删除的关联
     */
    fun onConnectionRemoved(itemIndex:Int, contentConnection: ContentConnectionDto, callback:(Result)->Unit){
        /*val _contents = Object.assign(arrayOf<ContentVo>(), contents)
        val item = _contents[itemIndex]
        val content = item.children.firstOrNull { it.id == contentConnection.contentId }
        if(content != null){
            val connectionsOfType = content.connections.firstOrNull { it.contentId == contentConnection.contentId && it.entityType == contentConnection.entityType }
            if(connectionsOfType != null){
                // 1. 创建新的 ContentConnections
                val newConnectionsOfType = Object.assign(ContentConnections(), connectionsOfType)
                newConnectionsOfType.connectedEntities = connectionsOfType.connectedEntities.filter { it.connectionId != contentConnection.id }.toSet()
                // 2. 创建新的 content，替换 connections
                val newContent = Object.assign(ContentVo(), content)
                newContent.connections = content.connections.map { if (it == connectionsOfType) newConnectionsOfType else it }.toTypedArray()
                // 3. 创建新的 children 数组
                val newChildren = item.children.map { if (it.id == content.id) newContent else it }.toTypedArray()
                // 4. 替换 itemIndex 处的 ContentVo
                _contents[itemIndex] = Object.assign(ContentVo(), item).apply { children = newChildren }
            }
        }
        setContents(_contents)*/
        queryContent(bookContentQuery)
        callback(Result(Error.NA,"删除成功"))
    }

    useEffectOnce {
       getContainers()
       //queryContent()
       ctx.getOptions({ resp->
            if(resp.ok()) {
                resp.data?.let{
                    setSignSymptomOptions(it)
                }
            }else{
                message.error("获取体征症状出错：${resp.message}")
            }
        },{
            message.error("获取体征症状出错：${it.message}")
        })
        /*ctx.fetchBookComments(CommentType.注解,bookId,"2",{resp->
            if(resp.ok()) {
                val _commentMap = Object.assign(hashMapOf(),commentMap)
                resp.data?.let { comments ->
                    comments.forEach { comment->
                        _commentMap.put(comment.entityId?:"",CommentVo(comment,false))
                    }
                }
                setCommentMap(_commentMap)
            }else{
                message.error("获取注解出错：${resp.message}")
            }
        },{
            message.error("获取注解出错：${it.message}")
        })*/
    }


/*    handleSearchChange = (event,data) => {
    this.setState({...this.state,searchKey:data.value});
}*/

/*    handleContextRef = (contextRef) => {
    this.setState({contextRef});
}*/

    div("ShangHanLunReading") {
        pageHeader {
            attrs{
                ghost = false
                title = "精读伤寒论"
                subTitle = "条文与注解"
                style = js {
                    position = "sticky"
                    top = "0"
                    zIndex = 100
                    backgroundColor = "white"
                    boxShadow = "0 2px 8px rgba(0,0,0,0.06)"
                    paddingBottom = "12px"
                    marginBottom = "16px"
                }
                extra = buildElement {
                    span{
                        +""
                    }
                }
            }

            form {
                attrs{
                    className = "advanced-search-form"
                }
                row {
                    attrs{
                        gutter = "24"
                    }
                    col{
                        attrs{
                            span = "8"
                            key = "chapter-input-1"
                        }
                        formItem {
                            attrs{
                                label = buildElement {
                                    div {
                                        attrs.jsStyle = js {
                                            display = "flex"
                                            flexDirection = "column"
                                            alignItems = "flex-start"
                                            lineHeight = "1.2"
                                        }
                                        div {
                                            +"章节"
                                        }
                                        div {
                                            +"（可左右滑动查看更多）"
                                            attrs.jsStyle = js {
                                                fontSize = "11px"
                                                color = "#999"
                                                marginTop = "2px"
                                                fontWeight = "normal"
                                                lineHeight = "1"
                                            }
                                        }
                                    }
                                }
                            }

                            select<String, SelectComponent<String>> {
                                attrs {
                                    value = bookContentQuery.id
                                    placeholder = "选择章节"

                                    filterOption = ::filterOptionFun
                                    onChange = { selected: String, any: Any ->
                                        window.localStorage.setItem("shanghanlun_reading_chapter", selected)
                                        val _bookContentQuery = Object.assign(ContentQuery(),bookContentQuery)
                                        _bookContentQuery.id = selected
                                        setBookContentQuery(_bookContentQuery)
                                        queryContent(_bookContentQuery)
                                    }
                                    style = js { width = "100%" }
                                }
                                option {
                                    attrs{
                                        label = "不限"
                                        value = ""
                                    }
                                    +"不限"
                                }
                                containers.forEach { opt->
                                    option {
                                        attrs{
                                            label = "${opt.label}"
                                            value = "${opt.value}"
                                        }
                                        +"${opt.label}"
                                    }
                                }
                            }
                        }
                    }
                    col{
                        attrs{
                            span = "8"
                            key = "search-input-1"
                        }
                        formItem {
                            attrs{
                                label = "关键词"
                            }
                            input {
                                attrs{
                                    value = bookContentQuery.keyword
                                    onChange = { event:dynamic ->
                                        val _bookContentQuery = Object.assign(ContentQuery(),bookContentQuery)
                                        _bookContentQuery.keyword = event.target.value as String
                                        setBookContentQuery(_bookContentQuery)
                                    }
                                }
                            }
                        }
                    }
                    col{
                        attrs{
                            span = "8"
                            key = "search-input-1"
                        }
                        formItem {
                            attrs{
                                label = "症状体征"
                            }

                            select<Array<String>, SelectComponent<Array<String>>> {
                                attrs {
                                    mode = "multiple"
                                    labelInValue = false
                                    value = bookContentQuery.signSymptomIds?:arrayOf()
                                    placeholder = "选择症状"
                                    optionLabelProp = "label"

                                    filterOption = ::filterOptionFun
                                    //onSearch = fetchUser
                                    onChange = { selected: Array<String>, any: Any ->
                                        console.log("select value",selected);
                                        val _bookContentQuery = Object.assign(ContentQuery(),bookContentQuery)
                                        _bookContentQuery.signSymptomIds = selected
                                        setBookContentQuery(_bookContentQuery)
                                    }
                                    style = js { width = "100%" }
                                }
                                signSymptomOptions.forEach { optGroup ->
                                    optGroup {
                                        attrs{
                                            label = "${optGroup.label}"
                                        }
                                        optGroup.children?.forEach { opt->
                                            option {
                                                attrs{
                                                    label = "${opt.label}"
                                                    value = "${opt.value}"
                                                }
                                                +"${opt.label}"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    /*col{
                        attrs{
                            span = "8"
                            key = "search-input-1"
                        }
                        formItem {
                            attrs{
                                label = "方"
                            }
                            input {
                                attrs{
                                    value = ""
                                    onChange = { event:dynamic ->
                                        val _bookContentQuery = Object.assign(ContentQuery(),bookContentQuery)
                                        _bookContentQuery.keyword = event.target.value as String
                                        setBookContentQuery(_bookContentQuery)
                                        //setSearchKey(event.target.value as String)
                                    }
                                }
                            }
                        }
                    }
                    col{
                        attrs{
                            span = "8"
                            key = "search-input-1"
                        }
                        formItem {
                            attrs{
                                label = "药"
                            }
                            input {
                                attrs{
                                    value = ""
                                    onChange = { event:dynamic ->
                                        //setSearchKey(event.target.value as String)
                                    }
                                }
                            }
                        }
                    }*/
                }
                row {
                    col{
                        attrs{
                            span = "24"
                            style = js {
                                textAlign = "right"
                            }
                        }
                        button {
                            attrs{
                                type = "primary"
                                onClick = {queryContent()}
                            }
                            +"查找"
                        }
                    }
                }
            }
        }

        div("content-wrap search-result-list"){
            attrs["key"] = "search-list-$refreshKey"

            contents.forEachIndexed { index, item ->
                child(ShangHanLunItem){
                    attrs{
                        keyword = ""
                        content = item
                        itemIndex = index
                        this.bookId = bookId
                        signSymptoms = signSymptomOptions
                        onSaveConnection = ::onSaveConnection
                        onConnectionRemoved = ::onConnectionRemoved
                        onEditAnnotation = ::openAnnotationModal
                        //comments = commentMap
                    }
                }
            }
        }

        // Annotation Edit Modal
        modal {
            attrs {
                title = "编辑注解"
                visible = showAnnotationModal
                maskClosable = false
                onOk = { handleSaveAnnotation() }
                onCancel = {
                    destroyAnnotationEditor()
                    setSaveAnnotationError(null)
                    setShowAnnotationModal(false)
                    setEditingAnnotation(null)
                    setAnnotationForm(Comment())
                }
                okText = if (savingAnnotation) "保存中..." else "保存"
                cancelText = "取消"
                confirmLoading = savingAnnotation
                width = 700
            }
            div {
                // 显示对应条文内容（只读）
                val articleChild = contents.flatMap { it.children?.asIterable() ?: emptyList() }
                    .firstOrNull { it.id == editingAnnotationContentId }
                val articleText = articleChild?.content
                if (!articleText.isNullOrBlank()) {
                    div {
                        attrs.jsStyle = js {
                            marginBottom = "16px"
                            padding = "12px"
                            backgroundColor = "#fafafa"
                            borderRadius = "4px"
                            borderLeft = "3px solid #1890ff"
                            fontSize = "14px"
                            lineHeight = "1.8"
                            color = "#333"
                            maxHeight = "150px"
                            overflowY = "auto"
                        }
                        div {
                            attrs.jsStyle = js {
                                fontSize = "12px"
                                color = "#999"
                                marginBottom = "6px"
                            }
                            +"条文原文${articleChild?.index?.let { "（第${it}条）" } ?: ""}"
                        }
                        div {
                            attrs["dangerouslySetInnerHTML"] = js { __html = articleText }
                        }
                    }
                }
                form {
                    formItem {
                    attrs { label = "标题" }
                    input {
                        attrs {
                            value = annotationForm.title ?: ""
                            placeholder = "请输入注解标题（可选）"
                            disabled = savingAnnotation
                            onChange = { event: dynamic ->
                                val newTitle = event.target.value as String
                                setAnnotationForm { current ->
                                    Object.assign(Comment(), current).apply {
                                        title = newTitle
                                    }
                                }
                            }
                        }
                    }
                }
                formItem {
                    attrs { label = "注解内容" }
                    div {
                        attrs.jsStyle = js {
                            border = "1px solid #d9d9d9"
                            borderRadius = "4px"
                            minHeight = "300px"
                        }
                        attrs["id"] = "annotation-editor-reading"
                    }
                    if (!saveAnnotationError.isNullOrBlank()) {
                        div {
                            attrs.jsStyle = js {
                                color = "#ff4d4f"
                                fontSize = "12px"
                                marginTop = "4px"
                            }
                            +saveAnnotationError!!
                        }
                    }
                }
                formItem {
                    attrs { label = "来源" }
                    input {
                        attrs {
                            value = annotationForm.source ?: ""
                            placeholder = "请填写注解来源（可选）"
                            disabled = savingAnnotation
                            onChange = { event: dynamic ->
                                val newSource = event.target.value as String
                                setAnnotationForm { current ->
                                    Object.assign(Comment(), current).apply {
                                        source = newSource
                                    }
                                }
                            }
                        }
                    }
                }
            }
            }
        }

        // 右下角刷新浮动按钮
        div {
            attrs.jsStyle = js {
                position = "fixed"
                bottom = "40px"
                right = "40px"
                zIndex = 1000
            }
            button {
                attrs {
                    type = "primary"
                    shape = "circle"
                    size = "large"
                    style = js {
                        width = "48px"
                        height = "48px"
                        fontSize = "20px"
                        boxShadow = "0 3px 6px rgba(0,0,0,0.15)"
                    }
                    onClick = {
                        setRefreshKey { it + 1 }
                        queryContent()
                    }
                }
                +"⟳"
            }
        }
    }
}
